import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';

export const SubmissionFailurePanel = ({
  backToDashboardString,
  submissionFailure,
  goToDashboard,
}) => {
  return (
    <div className={styles.panel}>
      <div className={styles.submissionMessage}>{submissionFailure}</div>
      <button onClick={goToDashboard} className={styles.button}>
        {backToDashboardString}
      </button>
    </div>
  );
};

export default enhance(SubmissionFailurePanel);
